(function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};

  // carousels: [data-bj-car] track + prev/next buttons inside [data-bj-car-wrap]
  $$('[data-bj-car-wrap]').forEach(function(w){
    var t=$('[data-bj-car]',w),p=$('[data-bj-prev]',w),n=$('[data-bj-next]',w);
    if(!t)return;
    var step=function(){var c=t.firstElementChild;return c?c.getBoundingClientRect().width+16:300};
    var upd=function(){if(p)p.disabled=t.scrollLeft<4;if(n)n.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-4};
    if(p)p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'})});
    if(n)n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'})});
    t.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    // gallery thumbs
    var th=$$('[data-bj-thumb]',w);
    if(th.length){
      var mark=function(){var i=Math.round(t.scrollLeft/t.clientWidth);th.forEach(function(b,k){b.classList.toggle('is-on',k===i)})};
      t.addEventListener('scroll',mark,{passive:true});
      th.forEach(function(b,k){b.addEventListener('click',function(){t.scrollTo({left:k*t.clientWidth,behavior:'smooth'})})});
      mark();
    }
  });

  // kit selector + add to cart (real product form so apps like Kaching Bundles can hook in)
  var form=$('[data-bj-form]');
  if(form){
    var qty=$('[data-bj-qty]',form),hasApp=form.getAttribute('data-bj-app')==='true';
    var kits=$$('.bj-kit',form);
    var chosen=1;var sync=function(){kits.forEach(function(k){var on=$('input',k).checked;k.classList.toggle('is-on',on);if(on){chosen=parseInt($('input',k).value,10)||1;if(qty)qty.value=chosen}})};
    kits.forEach(function(k){$('input',k).addEventListener('change',sync)});sync();
    var natives=$('.bj-kits',form);
    var nativeOn=function(){return natives&&!form.classList.contains('has-kaching')};
    var busy=function(on){$$('[data-bj-atc]').forEach(function(b){b.disabled=on})};
    // add then go straight to checkout (skip the cart). Kaching on: send the form as-is so its bundle tag + qty ride along
    var add=function(){
      var id=form.getAttribute('data-variant'),q=chosen;
      var body=nativeOn()?JSON.stringify({items:[{id:Number(id),quantity:q}]}):new FormData(form);
      var h={Accept:'application/json'};if(typeof body==='string')h['Content-Type']='application/json';
      busy(true);
      fetch('/cart/add.js',{method:'POST',headers:h,body:body})
        .then(function(r){if(!r.ok)throw 0;window.location.href='/checkout'})
        .catch(function(){busy(false);if(nativeOn()){window.location.href='/cart/'+id+':'+q}else{HTMLFormElement.prototype.submit.call(form)}});
    };
    // every add goes through add(), with or without Kaching Bundles
    var guard=function(e){e.preventDefault();e.stopImmediatePropagation();add()};
    form.addEventListener('submit',guard,true);
    var mainBtn=$('[data-bj-atc]',form);if(mainBtn)mainBtn.addEventListener('click',guard,true);
    if(hasApp){
      var tries=0,probe=setInterval(function(){
        var k=$('.bj-app',form);
        if(k&&k.offsetHeight>60){form.classList.add('has-kaching');clearInterval(probe)}
        if(++tries>40)clearInterval(probe);
      },250);
    }
  }
  // scroll to the bundle picker (Kaching Bundles when present, else the built-in kit selector)
  var goBuy=function(){var t=$('.bj-form .bj-app')||$('.bj-kits')||$('#bj-buy');if(t)t.scrollIntoView({behavior:'smooth',block:'center'})};
  $$('a[href="#bj-buy"]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();goBuy()})});
  // buttons outside the form (sticky bar, section CTAs) scroll to / submit the buy box
  $$('[data-bj-atc]').forEach(function(b){
    if(form&&form.contains(b))return;
    b.addEventListener('click',function(e){
      e.preventDefault();
      if(b.hasAttribute('data-bj-scroll')||!form){goBuy();return}
      add();
    });
  });

  // popup
  $$('[data-bj-open]').forEach(function(b){b.addEventListener('click',function(){var d=document.getElementById(b.getAttribute('data-bj-open'));if(d&&d.showModal)d.showModal()})});
  $$('dialog.bj-pop').forEach(function(d){
    d.addEventListener('click',function(e){if(e.target===d)d.close()});
    $$('[data-bj-close]',d).forEach(function(c){c.addEventListener('click',function(){d.close()})});
    $$('[data-bj-pop-buy]',d).forEach(function(c){c.addEventListener('click',function(){d.close();goBuy()})});
  });

  // clip play
  $$('[data-bj-play]').forEach(function(b){b.addEventListener('click',function(){
    var c=b.closest('.bj-clip'),v=$('video',c);if(!v)return;
    if(!v.getAttribute('src')&&v.getAttribute('data-src')){v.src=v.getAttribute('data-src')}
    v.controls=true;c.classList.add('is-playing');v.play()})});

  // sticky ATC
  var st=$('[data-bj-sticky]'),anchor=$('[data-bj-anchor]');
  if(st&&anchor&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){es.forEach(function(e){st.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(anchor);
  }

  // countdown (only when an end date is set); every [data-bj-end] on the page
  $$('[data-bj-end]').forEach(function(cd){
    var end=Date.parse(cd.getAttribute('data-bj-end')),cyc=(parseInt(cd.getAttribute('data-bj-cycle'),10)||0)*86400000,base=end;
    if(!end){if(cd.parentNode)cd.parentNode.style.display='none';return}
    var pad=function(n){return (n<10?'0':'')+n};
    var tick=function(){if(cyc){var n=Date.now(),r=((base-n)%cyc+cyc)%cyc;end=n+(r||cyc)}var s=Math.max(0,Math.floor((end-Date.now())/1000));var d=Math.floor(s/86400),h=Math.floor(s%86400/3600);cd.textContent=(d?d+'d ':'')+pad(h)+':'+pad(Math.floor(s%3600/60))+':'+pad(s%60)};
    tick();setInterval(tick,1000);
  });
})();
